import React, { useState, useEffect } from 'react';
import { TreeSelect } from '@douyinfe/semi-ui';
import request from '../../utils/request';

const ProductCategorySelector = ({ value, onChange, placeholder = '请选择分类', style = {} }) => {
    const [treeData, setTreeData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value === '0' ? null : value);

    useEffect(() => {
        setSelectedValue(value === '0' ? null : value);
    }, [value]);

    const fetchCategories = async (parentUid = '') => {
        try {
            setLoading(true);
            const response = await request.get('/go/sp/shop/mlist_product_cat/', {
                params: {
                    with_all_status: 1,
                    parent_uid: parentUid
                }
            });
            if (response.errno === 0) {
                return response.list || [];
            }
            return [];
        } catch (error) {
            console.error('获取分类列表失败:', error);
            return [];
        } finally {
            setLoading(false);
        }
    };

    const formatTreeData = (items) => {
        const formatted = items.map(item => ({
            label: item.name,
            value: item.uid,
            key: item.uid,
            children: item.children ? formatTreeData(item.children) : []
        }));
        return formatted;
    };

    const loadData = async (treeNode) => {
        if (treeNode.children && treeNode.children.length > 0) {
            return;
        }
        const children = await fetchCategories(treeNode.value);
        const formattedChildren = formatTreeData(children);
        treeNode.children = formattedChildren;
        setTreeData([...treeData]);
    };

    useEffect(() => {
        const initData = async () => {
            const data = await fetchCategories();
            const formattedData = formatTreeData(data);
            setTreeData(formattedData);
        };
        initData();
    }, []);

    const handleChange = (value) => {
        setSelectedValue(value);
        if (onChange) {
            onChange(value);
        }
    };

    return (
        <TreeSelect
            style={style}
            treeData={treeData}
            value={selectedValue}
            onChange={handleChange}
            placeholder={placeholder}
            loading={loading}
            loadData={loadData}
            filterTreeNode
            showClear
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeNodeFilterProp="label"
            showSearch
            searchPlaceholder="搜索分类"
            allowClear
        />
    );
};

export default ProductCategorySelector; 